const format_time = s => {
  if (s === 0) {
    return ''
  } else {
    const hour = new Intl.DateTimeFormat('en', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    }).format(s)

    return `${hour}`
  }
}

const format_date = d => {
  const ye = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(d)
  const mo = new Intl.DateTimeFormat('en', {month: '2-digit'}).format(d)
  const da = new Intl.DateTimeFormat('en', {day: '2-digit'}).format(d)
  return `${ye}-${mo}-${da}`
}

export {format_time, format_date}
